import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-phone_support-submit';
/**
 * Collecting phone related information while submitting phone support callback request
 */
export function trackHelpCenterPhoneSupportSubmit(retailerToken, brandToken, brandOrderToken, phone_number, email2, subject3, description4, details5 = '', userToken = '') {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            retailerToken,
            brandToken,
            brandOrderToken,
            phone_number,
            email2,
            subject3,
            description4,
            details5,
            userToken,
        },
    });
}
